import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
const container = document.getElementById('career-root');
if (container) {
    const root = createRoot(container);
    root.render(_jsx(App, {}));
}
